import React from 'react';

// 1. One Partner - End-to-End Accountability
export const OnePartnerSVG = () => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="60" cy="60" r="55" fill="#0f3b5e" opacity="0.05" stroke="#0f3b5e" strokeWidth="1.5"/>
    <circle cx="60" cy="60" r="45" fill="#0f3b5e" opacity="0.03" stroke="#0f3b5e" strokeWidth="1" strokeDasharray="4 4"/>
    
    {/* Central hub */}
    <circle cx="60" cy="60" r="18" fill="#0f3b5e" opacity="0.1"/>
    <circle cx="60" cy="60" r="10" fill="#0f3b5e" opacity="0.3"/>
    <circle cx="60" cy="60" r="5" fill="#0f3b5e" opacity="0.6"/>
    
    {/* Connected nodes */}
    {[
      { x: 60, y: 30, label: 'S' },
      { x: 60, y: 90, label: 'Q' },
      { x: 30, y: 60, label: 'C' },
      { x: 90, y: 60, label: 'L' },
      { x: 40, y: 38, label: 'E' },
      { x: 80, y: 38, label: 'C' },
      { x: 40, y: 82, label: 'D' },
      { x: 80, y: 82, label: 'T' },
    ].map((node, i) => (
      <g key={i}>
        <circle cx={node.x} cy={node.y} r="12" fill="white" stroke="#0f3b5e" strokeWidth="2"/>
        <circle cx={node.x} cy={node.y} r="8" fill="#0f3b5e" opacity="0.1"/>
        <text x={node.x} y={node.y + 4} textAnchor="middle" fontSize="8" fill="#0f3b5e" fontWeight="bold">{node.label}</text>
        <line x1="60" y1="60" x2={node.x} y2={node.y} stroke="#0f3b5e" strokeWidth="1.5" opacity="0.3"/>
      </g>
    ))}
    
    <text x="60" y="112" textAnchor="middle" fontSize="7" fill="#4a5568">Supplier · Engineering · QC · Compliance · Logistics</text>
  </svg>
);

// 2. Built for European Standards
export const EuropeanStandardsSVG = () => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="60" cy="60" r="55" fill="#0f3b5e" opacity="0.05" stroke="#0f3b5e" strokeWidth="1.5"/>
    
    {/* EU Flag Stars */}
    {[...Array(12)].map((_, i) => {
      const angle = (i / 12) * 2 * Math.PI - Math.PI / 2;
      const x = 60 + 35 * Math.cos(angle);
      const y = 60 + 35 * Math.sin(angle);
      return (
        <circle key={i} cx={x} cy={y} r="4" fill="#0f3b5e" opacity="0.6"/>
      );
    })}
    
    {/* Center shield */}
    <path d="M60 30 L75 40 L75 55 C75 67 68 76 60 80 C52 76 45 67 45 55 L45 40 L60 30Z" 
          fill="#0f3b5e" opacity="0.1" stroke="#0f3b5e" strokeWidth="2"/>
    
    {/* Checkmark in shield */}
    <path d="M52 55 L58 63 L70 48" stroke="#0f3b5e" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    
    {/* ESG text */}
    <text x="60" y="98" textAnchor="middle" fontSize="8" fill="#0f3b5e" fontWeight="bold">ESG · CSRD</text>
    <text x="60" y="108" textAnchor="middle" fontSize="6" fill="#4a5568">European Standards</text>
  </svg>
);

// 3. Sustainability Without Compromise
export const SustainabilitySVG = () => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="60" cy="60" r="55" fill="#22c55e" opacity="0.05" stroke="#22c55e" strokeWidth="1.5"/>
    
    {/* Earth/Globe */}
    <circle cx="60" cy="60" r="32" fill="#22c55e" opacity="0.08"/>
    <circle cx="60" cy="60" r="28" fill="none" stroke="#22c55e" strokeWidth="1.5" opacity="0.3"/>
    
    {/* Continents (simplified) */}
    <path d="M48 42 C52 38 58 40 60 44 C62 48 58 52 52 50 C48 48 44 46 48 42Z" fill="#22c55e" opacity="0.3"/>
    <path d="M68 48 C72 44 78 46 76 52 C74 58 68 56 68 48Z" fill="#22c55e" opacity="0.3"/>
    <path d="M50 62 C54 58 62 60 60 68 C58 72 52 70 50 62Z" fill="#22c55e" opacity="0.3"/>
    <path d="M66 66 C70 62 76 64 74 70 C72 74 66 72 66 66Z" fill="#22c55e" opacity="0.3"/>
    
    {/* Leaf */}
    <path d="M60 30 C50 40 45 55 52 70 C56 78 64 80 68 74 C74 65 70 50 60 30Z" 
          fill="#22c55e" opacity="0.2" stroke="#22c55e" strokeWidth="2"/>
    <path d="M60 30 L60 50" stroke="#22c55e" strokeWidth="2" strokeLinecap="round"/>
    <path d="M55 42 L60 48 L65 42" stroke="#22c55e" strokeWidth="1.5" strokeLinecap="round" opacity="0.6"/>
    
    {/* CO2 text */}
    <text x="60" y="102" textAnchor="middle" fontSize="9" fill="#22c55e" fontWeight="bold">↓ CO₂</text>
    <text x="60" y="112" textAnchor="middle" fontSize="6" fill="#4a5568">Reduction at source</text>
  </svg>
);

// 4. Quality You Can Verify
export const QualitySVG = () => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="60" cy="60" r="55" fill="#0f3b5e" opacity="0.05" stroke="#0f3b5e" strokeWidth="1.5"/>
    
    {/* Magnifying glass */}
    <circle cx="52" cy="52" r="22" fill="none" stroke="#0f3b5e" strokeWidth="3"/>
    <circle cx="52" cy="52" r="14" fill="#0f3b5e" opacity="0.06"/>
    <line x1="68" y1="68" x2="82" y2="82" stroke="#0f3b5e" strokeWidth="3" strokeLinecap="round"/>
    
    {/* Checkmark inside */}
    <path d="M45 52 L52 60 L62 48" stroke="#22c55e" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    
    {/* Small details */}
    <circle cx="40" cy="40" r="2" fill="#0f3b5e" opacity="0.3"/>
    <circle cx="64" cy="40" r="2" fill="#0f3b5e" opacity="0.3"/>
    <circle cx="40" cy="64" r="2" fill="#0f3b5e" opacity="0.3"/>
    
    {/* Quality text */}
    <text x="60" y="102" textAnchor="middle" fontSize="8" fill="#0f3b5e" fontWeight="bold">Quality Verified</text>
    <text x="60" y="112" textAnchor="middle" fontSize="6" fill="#4a5568">In-house QC · On-site inspections</text>
  </svg>
);

// 5. Curated Manufacturing Network
export const CuratedNetworkSVG = () => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="60" cy="60" r="55" fill="#0f3b5e" opacity="0.05" stroke="#0f3b5e" strokeWidth="1.5"/>
    
    {/* Network nodes */}
    {[
      { x: 60, y: 30, label: 'EU' },
      { x: 35, y: 50, label: 'P1' },
      { x: 85, y: 50, label: 'P2' },
      { x: 35, y: 80, label: 'P3' },
      { x: 85, y: 80, label: 'P4' },
    ].map((node, i) => (
      <g key={i}>
        <circle cx={node.x} cy={node.y} r={i === 0 ? 16 : 12} 
                fill={i === 0 ? '#0f3b5e' : 'white'} 
                stroke="#0f3b5e" strokeWidth={i === 0 ? 0 : 2}/>
        <circle cx={node.x} cy={node.y} r={i === 0 ? 12 : 6} 
                fill={i === 0 ? 'rgba(255,255,255,0.3)' : '#0f3b5e'} opacity="0.3"/>
        <text x={node.x} y={node.y + (i === 0 ? 5 : 4)} 
              textAnchor="middle" 
              fontSize={i === 0 ? 8 : 7} 
              fill={i === 0 ? 'white' : '#0f3b5e'} 
              fontWeight="bold">{node.label}</text>
        
        {/* Connection lines */}
        {i > 0 && (
          <line x1="60" y1="30" x2={node.x} y2={node.y} 
                stroke="#0f3b5e" strokeWidth="1.5" opacity="0.3"/>
        )}
        {i > 1 && i % 2 === 0 && (
          <line x1={node.x - 50} y1={node.y} x2={node.x} y2={node.y} 
                stroke="#0f3b5e" strokeWidth="1" opacity="0.15" strokeDasharray="3 3"/>
        )}
      </g>
    ))}
    
    <text x="60" y="112" textAnchor="middle" fontSize="6" fill="#4a5568">Curated · Verified · KPI-tracked</text>
  </svg>
);

// 6. Technology-Enabled Transparency
export const TechTransparencySVG = () => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="60" cy="60" r="55" fill="#0f3b5e" opacity="0.05" stroke="#0f3b5e" strokeWidth="1.5"/>
    
    {/* Dashboard screen */}
    <rect x="28" y="28" width="64" height="48" rx="6" fill="#0f3b5e" opacity="0.06" stroke="#0f3b5e" strokeWidth="2"/>
    
    {/* Screen header */}
    <rect x="32" y="32" width="56" height="6" rx="2" fill="#0f3b5e" opacity="0.15"/>
    <circle cx="36" cy="35" r="2" fill="#0f3b5e" opacity="0.3"/>
    <circle cx="42" cy="35" r="2" fill="#0f3b5e" opacity="0.3"/>
    <circle cx="48" cy="35" r="2" fill="#0f3b5e" opacity="0.3"/>
    
    {/* Data bars */}
    <rect x="34" y="42" width="10" height="14" rx="1" fill="#0f3b5e" opacity="0.2"/>
    <rect x="34" y="46" width="10" height="10" rx="1" fill="#0f3b5e" opacity="0.4"/>
    <rect x="46" y="40" width="10" height="16" rx="1" fill="#0f3b5e" opacity="0.2"/>
    <rect x="46" y="44" width="10" height="12" rx="1" fill="#0f3b5e" opacity="0.4"/>
    <rect x="58" y="44" width="10" height="12" rx="1" fill="#0f3b5e" opacity="0.2"/>
    <rect x="58" y="48" width="10" height="8" rx="1" fill="#0f3b5e" opacity="0.4"/>
    <rect x="70" y="42" width="10" height="14" rx="1" fill="#0f3b5e" opacity="0.2"/>
    <rect x="70" y="46" width="10" height="10" rx="1" fill="#0f3b5e" opacity="0.4"/>
    
    {/* Carbon footprint indicator */}
    <circle cx="76" cy="64" r="8" fill="#22c55e" opacity="0.15"/>
    <circle cx="76" cy="64" r="5" fill="#22c55e" opacity="0.4"/>
    <text x="76" y="66" textAnchor="middle" fontSize="5" fill="#22c55e" fontWeight="bold">CO₂</text>
    
    <text x="60" y="90" textAnchor="middle" fontSize="7" fill="#0f3b5e" fontWeight="bold">Real-time Tracking</text>
    <text x="60" y="100" textAnchor="middle" fontSize="6" fill="#4a5568">Carbon reporting · Documentation</text>
  </svg>
);

// 7. Hero Illustration - EU to Asia Bridge
export const HeroBridgeSVG = () => (
  <svg viewBox="0 0 500 380" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="500" height="380" rx="16" fill="#f0f4f8"/>
    
    {/* Background decorative circles */}
    <circle cx="80" cy="80" r="60" fill="#0f3b5e" opacity="0.03"/>
    <circle cx="420" cy="300" r="80" fill="#22c55e" opacity="0.03"/>
    
    {/* EU side - Building/Factory */}
    <rect x="40" y="160" width="80" height="100" rx="4" fill="#0f3b5e" opacity="0.1" stroke="#0f3b5e" strokeWidth="1.5"/>
    <rect x="50" y="180" width="15" height="20" rx="1" fill="#0f3b5e" opacity="0.2"/>
    <rect x="75" y="180" width="15" height="20" rx="1" fill="#0f3b5e" opacity="0.2"/>
    <rect x="50" y="210" width="15" height="20" rx="1" fill="#0f3b5e" opacity="0.2"/>
    <rect x="75" y="210" width="15" height="20" rx="1" fill="#0f3b5e" opacity="0.2"/>
    
    {/* EU Flag */}
    <rect x="70" y="120" width="30" height="20" rx="2" fill="#0f3b5e"/>
    {[...Array(6)].map((_, i) => {
      const angle = (i / 6) * 2 * Math.PI;
      const x = 85 + 6 * Math.cos(angle);
      const y = 130 + 6 * Math.sin(angle);
      return <circle key={i} cx={x} cy={y} r="1.5" fill="white"/>;
    })}
    
    {/* EU Label */}
    <text x="80" y="290" textAnchor="middle" fontSize="14" fill="#0f3b5e" fontWeight="bold">EUROPE</text>
    <text x="80" y="305" textAnchor="middle" fontSize="9" fill="#4a5568">Buyers</text>
    
    {/* Asia side - Factory */}
    <rect x="380" y="150" width="90" height="110" rx="4" fill="#22c55e" opacity="0.1" stroke="#22c55e" strokeWidth="1.5"/>
    <rect x="390" y="170" width="15" height="20" rx="1" fill="#22c55e" opacity="0.2"/>
    <rect x="415" y="170" width="15" height="20" rx="1" fill="#22c55e" opacity="0.2"/>
    <rect x="440" y="170" width="15" height="20" rx="1" fill="#22c55e" opacity="0.2"/>
    <rect x="390" y="200" width="15" height="20" rx="1" fill="#22c55e" opacity="0.2"/>
    <rect x="415" y="200" width="15" height="20" rx="1" fill="#22c55e" opacity="0.2"/>
    <rect x="440" y="200" width="15" height="20" rx="1" fill="#22c55e" opacity="0.2"/>
    
    {/* Chimney with smoke */}
    <rect x="450" y="120" width="10" height="30" fill="#22c55e" opacity="0.2"/>
    <circle cx="455" cy="115" r="6" fill="#22c55e" opacity="0.1"/>
    <circle cx="460" cy="108" r="8" fill="#22c55e" opacity="0.08"/>
    
    {/* Asia Label */}
    <text x="425" y="288" textAnchor="middle" fontSize="14" fill="#22c55e" fontWeight="bold">ASIA</text>
    <text x="425" y="303" textAnchor="middle" fontSize="9" fill="#4a5568">Manufacturing</text>
    
    {/* Bridge - The main connection */}
    <path d="M120 210 C180 170 240 160 300 170 C340 178 360 190 380 210" 
          stroke="#0f3b5e" strokeWidth="4" strokeLinecap="round" opacity="0.7"/>
    <path d="M120 230 C180 190 240 180 300 190 C340 198 360 210 380 230" 
          stroke="#0f3b5e" strokeWidth="3" strokeLinecap="round" opacity="0.4" strokeDasharray="8 6"/>
    
    {/* Bridge pillars */}
    <rect x="180" y="190" width="6" height="40" rx="2" fill="#0f3b5e" opacity="0.3"/>
    <rect x="240" y="185" width="6" height="45" rx="2" fill="#0f3b5e" opacity="0.3"/>
    <rect x="300" y="188" width="6" height="42" rx="2" fill="#0f3b5e" opacity="0.3"/>
    
    {/* Data flowing across bridge - AI/Technology elements */}
    <circle cx="160" cy="215" r="4" fill="#0f3b5e" opacity="0.5"/>
    <circle cx="200" cy="210" r="3" fill="#22c55e" opacity="0.5"/>
    <circle cx="230" cy="205" r="4" fill="#0f3b5e" opacity="0.4"/>
    <circle cx="270" cy="200" r="3" fill="#22c55e" opacity="0.4"/>
    <circle cx="310" cy="205" r="4" fill="#0f3b5e" opacity="0.5"/>
    <circle cx="350" cy="215" r="3" fill="#22c55e" opacity="0.5"/>
    
    {/* AI/Technology icons on bridge */}
    <text x="205" y="195" fontSize="12" fill="#0f3b5e" opacity="0.6">⚡</text>
    <text x="275" y="190" fontSize="12" fill="#22c55e" opacity="0.6">🤖</text>
    <text x="240" y="250" fontSize="10" fill="#0f3b5e" opacity="0.5">AI</text>
    
    {/* Bridge label */}
    <rect x="210" y="330" width="80" height="28" rx="14" fill="#0f3b5e" opacity="0.9"/>
    <text x="250" y="349" textAnchor="middle" fontSize="11" fill="white" fontWeight="600">SOURCING</text>
    <text x="250" y="360" textAnchor="middle" fontSize="7" fill="rgba(255,255,255,0.7)">Transparent · Compliant</text>
    
    {/* Sustainability icons */}
    <circle cx="125" cy="140" r="12" fill="#22c55e" opacity="0.08"/>
    <text x="125" y="144" textAnchor="middle" fontSize="12">🌱</text>
    
    <circle cx="430" cy="100" r="12" fill="#0f3b5e" opacity="0.06"/>
    <text x="430" y="104" textAnchor="middle" fontSize="12">♻️</text>
  </svg>
);

// 8. Values Section - Core Values SVG
export const CoreValuesSVG = () => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="60" cy="60" r="55" fill="#0f3b5e" opacity="0.05" stroke="#0f3b5e" strokeWidth="1.5"/>
    
    {/* Central star */}
    <circle cx="60" cy="60" r="20" fill="#0f3b5e" opacity="0.08"/>
    <circle cx="60" cy="60" r="12" fill="#0f3b5e" opacity="0.15"/>
    <circle cx="60" cy="60" r="6" fill="#0f3b5e" opacity="0.3"/>
    
    {/* 8 surrounding dots representing values */}
    {[...Array(8)].map((_, i) => {
      const angle = (i / 8) * 2 * Math.PI - Math.PI / 2;
      const x = 60 + 35 * Math.cos(angle);
      const y = 60 + 35 * Math.sin(angle);
      return (
        <g key={i}>
          <circle cx={x} cy={y} r="8" fill="white" stroke="#0f3b5e" strokeWidth="1.5"/>
          <circle cx={x} cy={y} r="4" fill="#0f3b5e" opacity="0.4"/>
          <line x1="60" y1="60" x2={x} y2={y} stroke="#0f3b5e" strokeWidth="1" opacity="0.2"/>
        </g>
      );
    })}
    
    <text x="60" y="102" textAnchor="middle" fontSize="7" fill="#0f3b5e" fontWeight="bold">8 Core Values</text>
    <text x="60" y="112" textAnchor="middle" fontSize="6" fill="#4a5568">Accountability · Transparency · Sustainability</text>
  </svg>
);

// 9. Start Free - Risk Free SVG
export const RiskFreeSVG = () => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="60" cy="60" r="55" fill="#0f3b5e" opacity="0.05" stroke="#0f3b5e" strokeWidth="1.5"/>
    
    {/* Shield */}
    <path d="M60 25 L80 38 L80 58 C80 72 72 82 60 88 C48 82 40 72 40 58 L40 38 L60 25Z" 
          fill="#0f3b5e" opacity="0.06" stroke="#0f3b5e" strokeWidth="2"/>
    
    {/* Shield inner */}
    <path d="M60 30 L75 40 L75 56 C75 67 68 76 60 80 C52 76 45 67 45 56 L45 40 L60 30Z" 
          fill="#0f3b5e" opacity="0.08"/>
    
    {/* Checkmark */}
    <path d="M50 55 L57 64 L72 48" stroke="#22c55e" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"/>
    
    {/* Stars */}
    <circle cx="42" cy="35" r="3" fill="#22c55e" opacity="0.3"/>
    <circle cx="78" cy="35" r="3" fill="#22c55e" opacity="0.3"/>
    <circle cx="42" cy="80" r="3" fill="#22c55e" opacity="0.3"/>
    <circle cx="78" cy="80" r="3" fill="#22c55e" opacity="0.3"/>
    
    {/* Free text */}
    <text x="60" y="104" textAnchor="middle" fontSize="9" fill="#0f3b5e" fontWeight="bold">€50 FREE</text>
    <text x="60" y="114" textAnchor="middle" fontSize="6" fill="#4a5568">Sample · Carbon Report</text>
  </svg>
);

// 10. Partnership - Partner Ecosystem SVG
export const PartnerEcosystemSVG = () => (
  <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="60" cy="60" r="55" fill="#0f3b5e" opacity="0.05" stroke="#0f3b5e" strokeWidth="1.5"/>
    
    {/* Handshake concept */}
    <path d="M35 65 C30 55 32 42 42 38 C48 35 55 38 58 42" stroke="#0f3b5e" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M85 65 C90 55 88 42 78 38 C72 35 65 38 62 42" stroke="#0f3b5e" strokeWidth="2.5" strokeLinecap="round"/>
    
    {/* Hands meeting */}
    <circle cx="60" cy="55" r="12" fill="#0f3b5e" opacity="0.06"/>
    <circle cx="60" cy="55" r="7" fill="#0f3b5e" opacity="0.15"/>
    <circle cx="60" cy="55" r="3" fill="#0f3b5e" opacity="0.3"/>
    
    {/* Partnership arrows */}
    <path d="M35 50 L25 50 L25 35 L35 35" stroke="#0f3b5e" strokeWidth="1.5" opacity="0.4" fill="none"/>
    <path d="M85 50 L95 50 L95 35 L85 35" stroke="#0f3b5e" strokeWidth="1.5" opacity="0.4" fill="none"/>
    
    {/* Growth arrows */}
    <path d="M45 78 L55 70 L65 78" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.6"/>
    <path d="M55 78 L60 72 L65 78" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.4"/>
    
    <text x="60" y="102" textAnchor="middle" fontSize="7" fill="#0f3b5e" fontWeight="bold">Long-term Partnership</text>
    <text x="60" y="112" textAnchor="middle" fontSize="6" fill="#4a5568">Growth · Loyalty · Rewards</text>
  </svg>
);